export const getRelativeDate = (timestamp: number) => {
  const now = Date.now(); // Current time in milliseconds

  const timestampMs = timestamp * 1000; // Convert timestamp to milliseconds

  const secondsPast = Math.floor((now - timestampMs) / 1000); // Find the difference in seconds

  if (secondsPast < 60) {
    return `${secondsPast} seconds ago`;
  } else if (secondsPast < 3600) {
    const minutes = Math.floor(secondsPast / 60);
    return `${minutes} minutes ago`;
  } else if (secondsPast < 86400) {
    const hours = Math.floor(secondsPast / 3600);
    return `${hours} hours ago`;
  } else {
    const days = Math.floor(secondsPast / 86400);
    return `${days} days ago`;
  }
};

export const formatCreatedDate = (dateCreated: number) => {
  const date = new Date(dateCreated * 1000);
  const month = date.toLocaleString("en-US", { month: "long" });
  const day = date.toLocaleString("en-US", { day: "numeric" });
  const year = date.toLocaleString("en-US", { year: "numeric" });
  return `${month} ${day}, ${year}`;
};
